<template>
    <div class="">
        <app-overlay-loader v-if="preloader" />
        <div class="card-body">
            <form ref="form" :data-url='selectedUrl ? `companiesResources/${inputs.id}` : `companiesResources`' class="mb-0">
                <div class="form-group">
                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('shipping_address_name') }}
                        </label>
                        <app-input class="col-md-8" type="text" v-model="inputs.name"
                            :placeholder="$t('address_name')" />
                    </div>

                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('address') }}

                        </label>
                        <app-input class="col-md-8" type="text" v-model="inputs.address"
                            :placeholder="$t('description')" />
                    </div>

                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('country') }}
                        </label>
                        <app-input class="col-md-8 mt-2 pt-1" :placeholder="$t('select_country')"
                            type="advance-search-select" fetch-url="/countries/serverside/selectable-name"
                            v-model="inputs.country" listValueField="name" :loaded-per-time="5" />
                    </div>

                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('state') }}

                        </label>
                        <app-input class="col-md-8 mt-2 pt-1" :placeholder="$t('select_state')"
                            type="advance-search-select" :fetch-url='`/countries/${inputs.country.id}/states`'
                            v-model="inputs.state" listValueField="name" :loaded-per-time="5" />
                    </div>

                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('city') }}

                        </label>
                        <app-input class="col-md-8 mt-2 pt-1" :placeholder="$t('select_city')"
                            type="advance-search-select" :fetch-url='`/states/${inputs.state.id}/cities`'
                            v-model="inputs.city" listValueField="name" :loaded-per-time="5" />
                    </div>

                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('postal_zip_code') }}

                        </label>
                        <app-input class="col-md-8" type="text" v-model="inputs.postal_zip_code" min="6"
                            :placeholder="$t('zip_code')" />
                    </div>

                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('email') }}
                        </label>
                        <app-input class="col-md-8" type="text" v-model="inputs.email" min="6"
                            :placeholder="$t('email')" />
                    </div>

                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('phone') }}

                        </label>
                        <app-input class="col-md-8" type="tel-input" v-model="inputs.phone"
                            :placeholder="$t('add_phone')" />
                    </div>

                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('ext') }}

                        </label>
                        <app-input class="col-md-8" type="number" v-model="inputs.ext" min="6"
                            :placeholder="$t('ext')" />
                    </div>

                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0 required">
                            {{ $t('status') }}

                        </label>
                        <app-input class="col-md-8 mt-2 pt-1" type="radio" :list="stateList" v-model="inputs.status" />
                    </div>

                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0 required">
                            {{ $t('is_port') }}

                        </label>
                        <app-input class="col-md-8 mt-2 pt-1" type="radio" :list="isPortList" v-model="inputs.isPort" />
                    </div>

                    <div class="mt-5 action-buttons">
                        <button type="button" class="btn btn-primary mr-2" @click="saveData">{{
                            $t('save') }}</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { FormMixin } from '../../../../../core/mixins/form/FormMixin.js';
import { ModalMixin } from "../../../../Mixins/ModalMixin";
import { validateInputs } from "../../../../../utils"

export default {
    name: "AddProductModal",
    mixins: [FormMixin, ModalMixin],
    data() {
        return {
            preloader: false,
            inputs: {
                name: '',
                postal_zip_code: '',
                ext: '',
                email: '',
                phone: '',
                address: '',
                country: { id: null, name: null },
                state:  { id: null, name: null },
                city: { id: null, name: null },
                status : 'active',
                isPort : 0,
            },
            stateList: [
                { id: 'active', value: "Active" },
                { id: 'inactive', value: "Inactive" }
            ],
            isPortList : [
                { id: 0, value : 'No'},
                { id: 1, value : 'Yes'},
            ],
            watchActive: false // bandera para controlar el watch
        }
    },

    methods: {
        validations() {
            const validations = {
                // name: { required: true,  message: this.$t('the_name_is_required') },
                // 'country.id': { required: true, message: this.$t('the_country_is_required') },
                // 'state.id': { required: true, message: this.$t('the_state_is_required') },
                // 'city.id': { required: true, message: this.$t('the_city_is_required') },
                // address: { required: true,  message: this.$t('the_address_is_required') },
                // postal_zip_code: { required: true,  message: this.$t('the postal zip code is required') },
                // ext: { required: true,  message: this.$t('the ext is required') },
            };

            if (!validateInputs(this, this.inputs, validations)) {
                return;
            }
            return true
        },

        saveData() {
            if (!this.validations()) {
                return;
            }
            const DataCompanies = JSON.parse(localStorage.getItem('DataCompanies')) || {};
            const DataContact = JSON.parse(localStorage.getItem('DataContact')) || {};
            const DataAddress = JSON.parse(localStorage.getItem('DataAddress')) || {};
            const combinedData = {
                DataCompanies: DataCompanies,
                DataContact: DataContact,
                DataAddress: DataAddress
            };
            this.save(combinedData)
        },
        beforeSubmit() {
            this.preloader = true;
        },
        afterSuccess(response) {
            this.$toastr.s(response.data.message);
            // Eliminar items de localStorage
            localStorage.removeItem('DataCompanies');
            localStorage.removeItem('DataContact');
            localStorage.removeItem('DataAddress');
            // Verificar si existe la URL de redirección
            if (response.data.data.redirect) {
                window.location.href = response.data.data.redirect;
                //('Redireccionando a:', response.data.data.redirect);
            } else {
                console.error('No redirect URL found in response.');
            }
        },

        afterSuccessFromGetEditData(response) {
            if (response.data.phone) this.phone = response.data.phone;
            this.inputs = response.data;
            this.preloader = false;
        },

        closeModal() {
            this.$emit('close-modal');
            this.preloader = false
        },

        beforeSubmit() {
            this.preloader = true;
        },
        afterFinalResponse() {
            this.preloader = false;

        },
        afterError(res) {
            this.$toastr.e(res.data.message);
        },
        clear() {
            this.inputs = {
                gender: 'male',
            };
            this.fieldStatus = {
                isSubmit: false
            }
        },
    },
    watch: {
        inputs: {
            deep: true, // Para detectar cambios profundos en el objeto
            handler(newVal) {
                // Guardamos los inputs en localStorage
                localStorage.setItem('DataAddress', JSON.stringify(newVal));
            }
        }
    },

    created() {
        // Recuperar datos de localStorage si existen
        this.isPort = 0;
        const savedInputs = localStorage.getItem('DataAddress');
        if (savedInputs) {
            this.inputs = JSON.parse(savedInputs);
        }
    }
}

</script>
